import { supabase } from '../../supabaseClient'

export async function saveProjectService({
  projectName,
  projectNotes,
  projectFocusAreaId,
  projectStatusId,
  currentUser,
  editingProjectId
}) {
  if (!projectName?.trim() || !currentUser) return

  if (editingProjectId) {
    const { error } = await supabase
      .from('projects')
      .update({
        name: projectName.trim(),
        notes: projectNotes?.trim() || '',
        status_id: projectStatusId || null,
        focus_area_id: projectFocusAreaId || null
      })
      .eq('id', editingProjectId)

    if (error) {
  console.error('Error saving project service:', error)
  throw error
}
    } else {
    const { data: project, error } = await supabase
      .from('projects')
      .insert({
        name: projectName.trim(),
        notes: projectNotes?.trim() || '',
        user_id: currentUser.id,
        status_id: projectStatusId || null,
        focus_area_id: projectFocusAreaId || null
      })
      .select()
      .single()

    if (error) {
      console.error('Error saving project:', error)
      throw error
    }

    return project
  }
}

export async function saveProjectTaskService({
  projectTaskName,
  projectTaskNotes,
  selectedProject,
  currentUser
}) {
  if (!projectTaskName?.trim() || !selectedProject || !currentUser) return

  const { error } = await supabase
    .from('tasks')
    .insert({
      name: projectTaskName.trim(),
      notes: projectTaskNotes?.trim() || '',
      project_id: selectedProject.id,
      user_id: currentUser.id
    })

  if (error) {
  console.error('Error saving project task:', error)
  throw error
}
}

export async function saveProjectRecurringService({
  projectRecurringName,
  projectRecurringNotes,
  projectRecurringFrequency,
  selectedProject,
  currentUser
}) {
  if (!projectRecurringName?.trim() || !selectedProject || !currentUser) return

  let recurrenceId = 1

  if (projectRecurringFrequency === 'daily') recurrenceId = 1
  if (projectRecurringFrequency === 'weekly') recurrenceId = 2
  if (projectRecurringFrequency === 'monthly') recurrenceId = 3
  if (projectRecurringFrequency === 'yearly') recurrenceId = 4

  const { error } = await supabase
    .from('recurring_tasks')
    .insert({
      name: projectRecurringName.trim(),
      notes: projectRecurringNotes?.trim() || '',
      recurrence_type_id: recurrenceId,
      project_id: selectedProject.id,
      user_id: currentUser.id,
      is_active: true,
      is_pausable: true
    })

  if (error) {
  console.error('Error saving project recurring task:', error)
  throw error
}
}

export async function deleteProjectService(projectId) {
  if (!projectId) return

  const { error } = await supabase
    .from('projects')
    .delete()
    .eq('id', projectId)

  if (error) {
  console.error('Error deleting project:', error)
  throw error
}
}

export async function fetchProjectsService(currentUser) {
  if (!currentUser) return []

  const { data, error } = await supabase
    .from('projects')
    .select(`
      *,
      status_levels (
        id,
        name,
        sort_order
      ),
      focus_area (
        id,
        name
      )
    `)
    .eq('user_id', currentUser.id)
    .order('id')

  if (error) {
    console.error(error)
    return []
  }

  return data
}

export async function archiveProjectService(projectId) {

    return await supabase
        .from('projects')
        .update({
            status_id: 11
        })
        .eq('id', projectId)
}